import { ca } from '@cian/analytics';

import { EDealStepModalTypes } from './content';

export function trackDealStepModalShow({
  modalType,
  source,
}: {
  modalType: EDealStepModalTypes;
  source: 'navigation' | 'learn_more';
}) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Show_sopr',
    label: {
      [EDealStepModalTypes.Application]: 'popup_application',
      [EDealStepModalTypes.DocumentSigning]: 'popup_signing_docs',
      [EDealStepModalTypes.RosreestrRegistration]: 'popup_rosreestr',
    }[modalType],
    page: { extra: { source } },
  });
}

export function trackGetConsultationClick(modalType: EDealStepModalTypes) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSalePromo',
    action: 'Click',
    label: {
      [EDealStepModalTypes.Application]: 'Popup_application',
      [EDealStepModalTypes.DocumentSigning]: 'Popup_signing_docs',
      [EDealStepModalTypes.RosreestrRegistration]: 'Popup_rosreestr',
    }[modalType],
  });
}
